module.exports = __webpack_public_path__ + "static/media/lb.131d87ea.svg";